<template>
	<SessionStart>
		<template v-slot:actionPanel>
			<div class="signin__action-panel-mail">
				<header class="signin__action-panel-header">
					{{ $t( "slice-apple.components.SignIn.actionTitle" ) }}
				</header>
				<div class="signin__action-panel-button-row">
					<SocialButtons
						:google-button-text="buttonText.google"
						:microsoft-button-text="buttonText.microsoft"
						:email-button-text="buttonText.email"
						:show-email-button="config.enableEmailSignup"
						@googleClick="onGoogleSignIn"
						@microsoftClick="onMicrosoftSignIn"
						@emailClick="onEmailSignIn"
					/>
				</div>
				<div class="signin__action-panel-sign-in-row">
					{{ $t( "slice-apple.components.SignIn.DontHaveAccountText" ) }}&nbsp;<a @click="onSignUp">{{ $t( "slice-apple.components.SignIn.SignUpText" ) }}</a>
				</div>
			</div>
		</template>
	</SessionStart>
</template>

<script>
import { Source } from "@teaming/common-enums";
import { foundation } from "@teaming/slice-engine";
import SessionStart from "./SessionStart";
import SocialButtons from "./SocialButtons";

export default {
	name: "SignIn",
	inject: [ "config", ],
	components: {
		SessionStart,
		SocialButtons,
	},
	computed: {
		buttonText() {
			return {
				google: this.$t( "slice-apple.components.SignIn.googleSignInButton" ),
				microsoft: this.$t( "slice-apple.components.SignIn.microsoftSignInButton" ),
				email: this.$t( "slice-apple.components.SignIn.emailSignInButton" ),
			};
		},
	},
	methods: {
		onGoogleSignIn() {
			const redirect = foundation().navigation.getCurrentRoute().query.redirect || "/";
			foundation().auth.login( Source.GOOGLE, { target: redirect, } );
		},
		onMicrosoftSignIn() {
			const redirect = foundation().navigation.getCurrentRoute().query.redirect || "/";
			foundation().auth.login( Source.OFFICE365, { target: redirect, } );
		},
		onEmailSignIn() {
			const redirect = foundation().navigation.getCurrentRoute().query.redirect || "/";
			foundation().auth.login( Source.EMAIL, { target: redirect, } );
		},
		onSignUp( e ) {
			e.stopPropagation();
			foundation().navigation.navigateToSignUp();
		},
	},
};
</script>

<style lang="scss" scoped>
.signin__action-panel-header {
	color: $signup-title-font-color;
	font-weight: 700;
	text-align: center;
	margin-bottom: 2.5rem;

	@include for-size('xs') {
		@include font-and-line-for(3);
	}

	@include for-size('sm') {
		@include font-and-line-for(3);
	}

	@include for-size('md') {
		@include font-and-line-for(3);
	}

	@include for-size('lg') {
		@include font-and-line-for(4);
	}
}

.signin__action-panel-mail {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	text-align: center;

	@include for-size('xs') {
		margin-top: 1.5rem;
	}

	@include for-size('sm') {
		margin-top: 2.5rem;
	}

	@include for-size('md') {
		margin-top: 2.5rem;
	}

	@include for-size('lg') {
		margin-top: 8rem;
	}
}

.signin__action-panel-sign-in-row {
	margin-top: 1.75rem;
	a {
		color: $default-hyperlink-font-color;
	}

	@include for-size('xs') {
		@include font-and-line-for(-1);
	}

	@include for-size('sm') {
		@include font-and-line-for(0);
	}

	@include for-size('md') {
		@include font-and-line-for(0);
	}

	@include for-size('lg') {
		@include font-and-line-for(0);
	}
}
</style>
